/**
 * Adds the required `jsonrpc` property to an object.
 */
function base(instance) {
    Object.defineProperty(instance, 'jsonrpc', {
        get: function () { return '2.0'; }
    });
}

export { base };
